import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Modal from '../../../UI/Modal/Modal';
import cl from './ServiceDropdown.module.css';

const ServiceDropdown = ({ carService, car }) => {
  const { t, i18n } = useTranslation();
  const [carState, setCarState] = useState(car);
  const [isCarServiceConfirmationOpen, setIsCarServiceConfirmationOpen] = useState(false);
  const [tmpCarService, setTmpCarService] = useState(car.service);
  const [showDropdownServices, setShowDropdownServices] = useState(null);
  const dropdownServicesRef = useRef(null); 

  const services = [
    { value: 1, label: t('PurchaseTransportation') },
    { value: 2, label: t('Transportation') },
    { value: 3, label: t('Purchase') },
    { value: 4, label: t('Deposit') },
    { value: 5, label: t('Inspection') },
  ];

  const isChangeable = carState.service === 4 || carState.service === 5;
  const changeOptions = services.filter(opt => [1, 2, 3].includes(opt.value));

  const toggleServices = (carId) => {
    if (!isChangeable) return;
    setShowDropdownServices(prev => (prev === carId ? null : carId));
  };

  const openCarServiceChangeConfirmation = (selectedOption) => {
    setTmpCarService(selectedOption.value);
    setIsCarServiceConfirmationOpen(true);
  };

  const closeCarServiceChangeConfirmation = () => {
    setIsCarServiceConfirmationOpen(false);
  };

  const confirmCarServiceChange = () => {
    setCarState(prev => ({ ...prev, service: tmpCarService || 0 }));
    carService.updateService(car.id, tmpCarService);
    setIsCarServiceConfirmationOpen(false);
    setShowDropdownServices(null);
  };

  
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownServicesRef.current && !dropdownServicesRef.current.contains(event.target)) {
        setShowDropdownServices(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  
  const selectStyle = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      border: '1px solid var(--border-color)',
      boxShadow: 'none',
      minHeight: 'unset',
      height: '22px',
      cursor: isChangeable ? 'pointer' : 'not-allowed',
      borderRadius: '5px',
      '&:hover': { border: '1px solid var(--border-color)' },
      opacity: isChangeable ? 1 : 0.6,
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: 'var(--muted-text-color)',
      padding: '3px 3px 3px 0',
      svg: { width: '14px', height: '14px' },
    }),
    indicatorSeparator: provided => ({ ...provided, display: 'none' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const backgroundColor = isSelected || isFocused ? '#f1f1f1' : undefined;
      return {
        ...styles,
        fontSize: '12px',
        padding: '5px 8px',
        alignItems: 'center',
        display: 'flex',
        color: 'var(--text-color)',
        backgroundColor,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        ':before': {
          backgroundColor: isSelected ? data.color : data.color,
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 10,
          width: 10,
        },
      };
    },
    input: styles => ({ ...styles, margin: 0, padding: 0, fontSize: '12px' }),
    valueContainer: styles => ({ ...styles, padding: '1px' }),
    singleValue: styles => ({ ...styles, fontSize: '12px' }),
  };

  return (
    <>
      {isChangeable ? (
        showDropdownServices === car.id && (
          <div style={{ width: '100%', minWidth: 150 }} ref={dropdownServicesRef}>
            <Select
              styles={selectStyle}
              options={changeOptions}
              value={changeOptions.find(opt => opt.value === carState.service)}
              onChange={openCarServiceChangeConfirmation}
              isClearable={false}
              isSearchable={false}
            />
          </div>
        )
      ) : (

        <div
          style={{ whiteSpace: 'nowrap', backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22, opacity: 0.8 }}
        >
          {services.find(opt => opt.value === carState.service)?.label}
        </div>
      )}

      {isChangeable && showDropdownServices !== car.id && (

<div
          onClick={() => toggleServices(car.id)}
          style={{ whiteSpace: 'nowrap', backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22, cursor: 'pointer' }}
        >
          {services.find(opt => opt.value === carState.service)?.label}
        </div>
      )}

      <Modal key={car.id} size="medium" isOpen={isCarServiceConfirmationOpen} onClose={closeCarServiceChangeConfirmation}>
        <div className={cl.modalHead}>
          <h3>დადასტურება</h3>
        </div>
        <div className={cl.message}>გსურთ მომსახურების სერვისის შეცვლა?</div>
        <div className={cl.buttons}>
          <button className={cl.btnPrimary} style={{ marginTop: '2rem' }} onClick={confirmCarServiceChange}>
            დიახ მსურს!
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ServiceDropdown;
